module.exports = __webpack_public_path__ + "img/academy-badge-expert-course.a344112.svg";